module.exports = __webpack_public_path__ + "img/priceTag.333fbd7c.svg";